var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"scale"}},[(_vm.showFlag)?_c('div',{staticClass:"toast flex-wrap"},[_c('div',{staticClass:"toastWin"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.text))])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2ce02f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/toast/toast.vue
// module id = null
// module chunks = 